var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6.4,
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22888 5.49813C7.22888 5.883 7.54176 6.19249 7.93997 6.19249C8.33818 6.19249 8.65106 5.883 8.65106 5.49813C8.64699 5.10532 8.33818 4.7998 7.93997 4.7998C7.54176 4.7998 7.22888 5.10532 7.22888 5.49813ZM6.16021 10.6919C6.16428 11.0014 6.3837 11.1998 6.72502 11.1998H9.25244C9.59376 11.1998 9.81318 11.0014 9.81724 10.6919C9.82131 10.3745 9.60189 10.1761 9.25244 10.1761H8.64293V7.51375C8.64293 7.19237 8.42757 6.99398 8.1025 6.99398H6.83879C6.48934 6.99398 6.26992 7.19237 6.26992 7.50979C6.27399 7.81927 6.49341 8.01766 6.83879 8.01766H7.53363V10.1761H6.72502C6.37557 10.1761 6.15615 10.3745 6.16021 10.6919Z",
    fill: "currentColor",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfo);
export default __webpack_public_path__ + "static/media/ic-info.c941fb4e06fce60db75f95caa151ff9e.svg";
export { ForwardRef as ReactComponent };